export default __webpack_public_path__ + "static/media/PowerButton.f245d7d1.svg";